import React, { useState } from "react";
import ReactDatatable from "@mkikets/react-datatable";
import { useGetNetworkQuery } from "../../../redux/networkApi";
import { Button } from "react-bootstrap";
import EditNetwork from "../../partial/EditNetwork";

import { useTranslation } from "react-i18next";

function Networks() {
    const { t } = useTranslation();
    const { data: apiResponse } = useGetNetworkQuery();

    const users = apiResponse?.data || [];

    // Edit Modal State
    const [showEdit, setShowEdit] = useState(false);
    const [editData, setEditData] = useState({});

    const handleEdit = (network) => {
        setEditData(network);
        setShowEdit(true);
    };

    const columns = [
        {
            key: "srno.",
            text: t('sr_no'),
            className: "sr_no.",
            align: "left",
            sortable: true,
            cell: (row, index) => index + 1,
        },
        {
            key: "name",
            text: t('name'),
            className: "name",
            align: "left",
            sortable: true,
            cell: (record) => {
                return <><a href={record.explorer_url} target="_blank">{record.name}</a></>;
            },
        },
        {
            key: "symbol",
            text: t('symbol'),
            className: "name",
            align: "left",
            sortable: true,
        },
        {
            key: "is_evm",
            text: t('is_evm'),
            className: "is_evm",
            align: "left",
            sortable: true,
        },
        {
            key: "is_default",
            text: t('is_default'),
            className: "is_default",
            align: "left",
            sortable: true,
        },
        {
            key: "wallet_type",
            text: t('wallet_type'),
            className: "wallet_type",
            align: "left",
            sortable: true,
        },
        {
            key: "status",
            text: t('status'),
            className: "status",
            align: "left",
            sortable: true,
        },
        {
            key: "action",
            text: t('actions'),
            className: "Action d-flex",
            align: "left",
            sortable: true,
            cell: (record) => {
                return (
                    <>
                        <Button variant="info" size="sm" className="me-1" onClick={() => handleEdit(record)}>
                            {t('edit')}
                        </Button>
                    </>
                );
            },
        },
    ];

    const config = {
        page_size: 5,
        length_menu: [5, 10, 20, 50],
        filename: "Fund Request List",
        no_data_text: t('no_record_found'),
        button: {
            // print: true,
            // csv: true,
        },
        language: {
            filter: t('search_in_records'),

            pagination: {
                first: t('first'),
                previous: t('previous'),
                next: t('next'),
                last: t('last'),
            },
        },
        show_length_menu: true,
        show_filter: false,
        show_pagination: true,
        show_info: true,
    };

    return (
        <section className="section dashboard">
            <div className="pagetitle d-flex align-items-center justify-content-between mb-4">
                <h1>{t('networks')}</h1>
            </div>

            <div className="card">
                <div className="card-body pt-4">
                    <ReactDatatable
                        key={`datatable-aa`}
                        config={config}
                        records={users}
                        columns={columns}
                        dynamic={false}

                    />

                </div>
            </div>

            <EditNetwork
                show={showEdit}
                onHide={() => setShowEdit(false)}
                network={editData}
            />
        </section>
    );
}

export default Networks;
